import { useIsMounted } from '@core/js/hooks/useIsMounted';
import { useCallback, useRef, useEffect } from 'react';

export const useRequestAnimationFrame = <T extends unknown[]>(callback: (...args: T) => void) => {
    const animationFrameRef = useRef<number | null>(null);
    const getIsMounted = useIsMounted();
    const isMounted = getIsMounted();

    const wrappedCallback = useCallback(
        (...args: T) => {
            if (!isMounted) {
                return;
            }

            animationFrameRef.current = requestAnimationFrame(() => {
                callback(...args);
            });
        },
        [callback, isMounted]
    );

    useEffect(() => {
        return () => {
            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    return wrappedCallback;
};
